export var EMapType;
(function (EMapType) {
    EMapType[EMapType["M2D"] = 0] = "M2D";
    EMapType[EMapType["M3D"] = 1] = "M3D";
})(EMapType || (EMapType = {}));
export var EMapStyle;
(function (EMapStyle) {
    EMapStyle[EMapStyle["LIGHT"] = 0] = "LIGHT";
    EMapStyle[EMapStyle["DARK"] = 1] = "DARK";
})(EMapStyle || (EMapStyle = {}));
//# sourceMappingURL=interfaces.js.map